import React from "react";
import { Fragment } from "react";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import AggridTable from "../components/Admin/Reusable/AggridTable";
import ButtonColumn from "../components/Admin/Reusable/ButtonColumn";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { fetchDeleteProduct, fetchSyncList } from "../actions/product";

import LoadingIndicator from "../components/Admin/Reusable/LoadingIndicator";

const ProductSync = () => {
  const dispatch = useDispatch();

  const { loading, dataSyncList } = useSelector(
    (state) => state.productReducer
  );

  useEffect(() => {
    dispatch(fetchSyncList());
  }, [dispatch]);

  //akcija brisanja iz liste
  const handleSubmitModal = (pageId) => {
    dispatch(fetchDeleteProduct(pageId));
  };

  const imageRenderer = (params) => (
    <img
      src={params.data.slika}
      className="img-fluid image-preview-block-table"
      alt="UP IT"
    />
  );

  const customCellRenderer = (params) => (
    <ButtonColumn
      editLink={`/adminManager/product-edit/` + params.data.anId}
      deleteItemId={params.data.anId}
      deleteItemTitle={params.data.acName}
      value={params}
      submitActionModal={handleSubmitModal}
    />
  );

  //settings za tabelu
  const columnDefs = [
    {
      headerName: "Kompanija",
      field: "company",
      filter: true,
      minWidth: 100,
      flex: 1,
    },
    {
      headerName: "Datum pocetka azuriranja",
      field: "createdAt",
      filter: "agTextColumnFilter",
      width: 300,
    },
    {
      headerName: "Datum zavrsetka azuriranja",
      field: "endTime",
      filter: "agTextColumnFilter",
      width: 300,
    },
    {
      headerName: "Status",
      field: "status",
      filter: "agTextColumnFilter",
    },
  ];

  return (
    <Fragment>
      <Breadcrumb title="Pregled azuriranja podataka" type="product-sync" />
      <AggridTable
        rowData={dataSyncList}
        columnDefs={columnDefs}
        paginationPageSize={150}
      />
      <LoadingIndicator loading={loading} />
    </Fragment>
  );
};

export default ProductSync;
